import { FaMapMarkerAlt } from 'react-icons/fa'
import { FiEdit2 } from 'react-icons/fi'
import { MdQrCode } from 'react-icons/md'

import { Box, HStack, Square, Text, VStack } from '@chakra-ui/react'
import { AnimatePresence, motion } from 'framer-motion'

export interface CheckpointListItemIProps {
  id: string
  label: string
  subLabel: string
  isEditMode: boolean
  placed?: boolean
  selected?: boolean
  onClick?: () => void
  onDeviceItemHoverIn?: (deviceId: string) => void
  onDeviceItemHoverOut?: () => void
}

export const CheckpointListItem = ({
  id,
  label,
  subLabel,
  isEditMode,
  placed,
  selected,
  onClick,
  onDeviceItemHoverIn,
  onDeviceItemHoverOut,
}: CheckpointListItemIProps) => {
  return (
    <HStack
      _active={{
        backgroundColor: selected ? '#D8E2FF' : '#DCDFE4',
        boxShadow:
          '0px 0px 1px rgba(9, 30, 66, 0.31), 0px 1px 1px rgba(9, 30, 66, 0.25)',
      }}
      _hover={{
        backgroundColor: selected ? '#D8E2FF' : '#F1F2F4',
        boxShadow:
          '0px 0px 1px rgba(9, 30, 66, 0.31), 0px 8px 12px rgba(9, 30, 66, 0.15)',
      }}
      backgroundColor={selected ? '#EDF0FF' : '#fff'}
      borderRadius='4px'
      boxShadow='0px 0px 1px rgba(9, 30, 66, 0.31), 0px 1px 1px rgba(9, 30, 66, 0.25)'
      cursor={isEditMode && !placed ? 'move' : 'pointer'}
      justifyContent='space-between'
      onClick={onClick}
      onMouseEnter={() => onDeviceItemHoverIn?.(id)}
      onMouseLeave={() => onDeviceItemHoverOut?.()}
      p='8px'
      role='group'
      transition='ease-in-out'
      transitionDuration='300ms'
      transitionProperty='all'
    >
      <HStack flexShrink={1} isTruncated minWidth='0' spacing='12px'>
        <AnimatePresence>
          {placed ? (
            <Square
              animate={{ opacity: 1 }}
              as={motion.div}
              bgColor='#43BF9B'
              borderRadius='5px'
              exit={{ opacity: 0 }}
              initial={{ opacity: 0 }}
              size='24px'
            >
              <FaMapMarkerAlt color='#fff' size={12} />
            </Square>
          ) : (
            <Box
              animate={{ opacity: 1 }}
              as={motion.div}
              exit={{ opacity: 0 }}
              initial={{ opacity: 0 }}
            >
              <MdQrCode color='#44546F' size={24} />
            </Box>
          )}
        </AnimatePresence>

        <VStack align='flex-start' flexShrink={1} isTruncated spacing='0'>
          <Text
            color='#172B4D'
            fontSize='14px'
            fontWeight={500}
            isTruncated
            lineHeight='20px'
            w='full'
          >
            {label}
          </Text>

          <AnimatePresence>
            {placed ? (
              <HStack
                animate={{ opacity: 1 }}
                as={motion.div}
                exit={{ opacity: 0 }}
                flexShrink={1}
                initial={{ opacity: 0 }}
                spacing='2px'
                w='full'
              >
                <Box>
                  <MdQrCode color='#44546F' size={12} />
                </Box>
                <Text
                  color='#172B4D'
                  fontSize='12px'
                  fontWeight={400}
                  isTruncated
                  lineHeight='18px'
                  w='full'
                >
                  {subLabel}
                </Text>
              </HStack>
            ) : (
              <Box
                animate={{ opacity: 1 }}
                as={motion.div}
                exit={{ opacity: 0 }}
                initial={{ opacity: 0 }}
                w='full'
              >
                <Text
                  color='#172B4D'
                  fontSize='12px'
                  fontWeight={400}
                  isTruncated
                  lineHeight='18px'
                >
                  {subLabel}
                </Text>
              </Box>
            )}
          </AnimatePresence>
        </VStack>
      </HStack>
      {isEditMode && (
        <HStack
          _groupHover={{
            opacity: 1,
          }}
          backgroundColor='rgba(9, 30, 66, 0.06)'
          borderRadius='2px'
          opacity={0}
          p='4px'
          transition='ease-in-out'
          transitionDuration='300ms'
          transitionProperty='all'
        >
          <Box>
            <FiEdit2 color='#44546F' size={10} />
          </Box>
          <Text
            color='#44546F'
            fontSize='11px'
            fontWeight={500}
            lineHeight='16px'
          >
            Edit
          </Text>
        </HStack>
      )}
    </HStack>
  )
}
